import React from "react";

// Styles //
import "./infoCard.scss";

interface InfoCardProps {
    title: string;
    description: string;
    imageUrl: string;
    active: number;
    index: number;
    onClick: () => void;
}

const InfoCard = ({
    title,
    description,
    imageUrl,
    active,
    index,
    onClick,
}: InfoCardProps) => {
    return (
        <div
            className={`m-info-card ${active === index ? "active" : ""}`}
            onClick={onClick}
        >
            <span className="m-info-card__arrow">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23.206"
                    height="13.82"
                    viewBox="0 0 23.206 13.82"
                >
                    <g
                        id="flecha-curva"
                        transform="translate(55.652 171.544) rotate(-173)"
                    >
                        <g
                            id="Grupo_15492"
                            data-name="Grupo 15492"
                            transform="translate(52.731 155.283)"
                        >
                            <path
                                id="Trazado_76036"
                                data-name="Trazado 76036"
                                d="M320.378,208.336a.76.76,0,0,0,.169-1.5l-6.4-1.47a.759.759,0,1,0-.34,1.48l6.4,1.47A.764.764,0,0,0,320.378,208.336Z"
                                transform="translate(-313.214 -205.347)"
                            />
                        </g>
                        <g
                            id="Grupo_15493"
                            data-name="Grupo 15493"
                            transform="translate(52.731 155.282)"
                        >
                            <path
                                id="Trazado_76037"
                                data-name="Trazado 76037"
                                d="M406.476,213.286a.76.76,0,0,0,.741-.929l-1.466-6.422a.759.759,0,1,0-1.481.338l1.465,6.422A.76.76,0,0,0,406.476,213.286Z"
                                transform="translate(-404.251 -205.345)"
                            />
                        </g>
                        <g
                            id="Grupo_15494"
                            data-name="Grupo 15494"
                            transform="translate(52.918 152.411)"
                        >
                            <path
                                id="Trazado_76038"
                                data-name="Trazado 76038"
                                d="M64.145,163.649A10.477,10.477,0,0,0,74.6,153.17a.759.759,0,1,0-1.519,0,8.957,8.957,0,0,1-8.933,8.96,8.863,8.863,0,0,1-6.293-2.6l-3.824-3.834a.759.759,0,0,0-1.076,1.073l3.825,3.836A10.374,10.374,0,0,0,64.145,163.649Z"
                                transform="translate(-52.731 -152.411)"
                            />
                        </g>
                    </g>
                </svg>
            </span>
            <figure>
                <img src={imageUrl} alt={title} />
                <figcaption>{title}</figcaption>
            </figure>
            <div className="m-info-card__description">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </div>
    );
};

export default InfoCard;
